import { formatMesRef } from "@/lib/format";
import { mesCurto, porcento } from "@/data/dashboard";

/** "2026-01" -> "2025-12". */
export const competenciaAnterior = (competencia: string) => {
  const [a, m] = competencia.split("-").map(Number);
  return `${m === 1 ? a - 1 : a}-${String(m === 1 ? 12 : m - 1).padStart(2, "0")}`;
};

/** "2026-09" -> "Setembro de 2026". */
export const nomeCompetencia = (competencia: string) => {
  const nome = formatMesRef(competencia);
  return nome.charAt(0).toUpperCase() + nome.slice(1);
};

/** "▲ 4,2%" / "▼ 1,0%" / "= 0,0%"; null sem base de comparação. Sem cor: custo subir não é bom nem ruim por si só. */
export const setaVariacao = (atual: number, anterior: number): string | null => {
  if (!anterior) return null;
  const v = (atual - anterior) / Math.abs(anterior);
  return `${v > 0 ? "▲" : v < 0 ? "▼" : "="} ${porcento(Math.abs(v))}`;
};

/** "▲ 4,2% vs ago/26", ou "sem base no mês anterior". */
export const textoVariacao = (atual: number, anterior: number, competencia: string) => {
  const seta = setaVariacao(atual, anterior);
  return seta ? `${seta} vs ${mesCurto(competenciaAnterior(competencia))}` : "sem base no mês anterior";
};
